<template>
    <div :style="'height: ' + spacingDesktop + 'px'" class="hidden lg:block"></div>
    <div :style="'height: ' + spacingMobile + 'px'" class="lg:hidden"></div>
</template>

<script setup lang="ts">
    defineOptions({ inheritAttrs: false });

    const props = defineProps<{
        _key?: any;
        _type?: any;
        type?: any;
        shopwareId?: any;
        componentId?: any;
        typePage?: any;
        spacingDesktop?: number | null;
        spacingMobile?: number | null;
        blog?: boolean;
    }>();

    // Define emits even though this component doesn't emit anything
    // This prevents the warning about extraneous event listeners
    defineEmits<{
        imageLoaded: [];
    }>();
</script>
